import { selectNetPosition } from '../store/compositeSelectors/wallet/selectNetPosition';
import { useCoreSelector } from '../store/CoreStore';

export const useNetPositionConnected = (): number | undefined => {
  return useCoreSelector(selectNetPosition);
};
